<template>
  <router-link tag="a" :to="{path:'/bounty',query:{id:target.id}}" class="bounty-item">
    <div class="bounty-item__left">
      <h2 class="g-title title g-font-bold">{{ target.title }}</h2>
      <div class="labels">
        <LabelItem class="labels__item" v-for="item in target.types" :key="item.id" :label="item.value"/>
      </div>
      <InfoItem :label="$t('personal.difficulty')">{{ difficulty }}</InfoItem>
      <InfoItem :label="$t('personal.remaining')">{{ remain }}</InfoItem>
      <InfoItem :label="$t('personal.submit')">{{ target.submits }}</InfoItem>
      <slot />
      <UserItem class="user" :avatar="target.Creator.avatar" :name="target.Creator.name" :ont="target.Creator.ontid" />
    </div>
    <div class="bounty-item__right">
      <BountyReward
        :amountType="target.amount_type"
        :type="target.reward_type"
        :val="target.reward_type===1?target.reward_usdt:target.reward_amount"
        :coin="target.reward_token"
      />
    </div>
  </router-link>
</template>

<script>
import LabelItem from '@/components/LabelItem.vue';
import InfoItem from '@/components/InfoItem.vue';
import UserItem from '@/components/UserItem.vue';
import { getRemainingLabel } from '@/utils/business';
import BountyReward from '@/components/BountyReward.vue';

export default {
  name: 'BountyItem',
  components: {
    BountyReward,
    UserItem,
    InfoItem,
    LabelItem,
  },
  props: {
    target: {
      type: Object,
      require: true,
    },
  },
  computed: {
    difficulty() {
      return this.$t(`personal.difficulty${this.target.level}`);
    },
    remain() {
      return getRemainingLabel(this.target.status, this.target.expire_time);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/styles/var.scss';

  .bounty-item {
    display: flex;
    padding: 30px $padding-sm;
    overflow: hidden;
    background: var(--background-common);
    cursor: pointer;

    &:hover {
      box-shadow: 0 10px 20px 0 rgba(0,0,0,0.06);
    }
  }

  .bounty-item__left {
    flex: 1;
    padding-right: $padding-common;
    max-width: 340px;
  }

  .bounty-item__right {
    margin-left: auto;
  }

  .title {
    font-size: 22px;
    line-height: 30px;
  }

  .labels {
    margin-top: 10px;
    margin-bottom: 30px;
  }

  .labels__item {
    margin-top: 10px;
    margin-right: 10px;
  }

  .user {
    margin-top: 30px;
  }
</style>
